/* Pod LP kit: comportamento das sections pod-lp-*.liquid
   Portado da LP Elementor (.pkx). Cada bloco é inicializado por section,
   via atributos data-*, para permitir mais de uma instância por página. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var fmt = function (n) { return 'R$ ' + Math.round(n).toLocaleString('pt-BR'); };
  var fmt2 = function (n) { return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var DL = window.dataLayer = window.dataLayer || [];

  /* ========== Oferta: kits -> sabores -> checkout Yampi ========== */
  function initOferta(root) {
    var base = +root.dataset.base || 0;          // preço cheio por garrafa
    var yampiBase = root.dataset.yampiBase || ''; // ex.: https://seguro.pod.com.br/b/
    var fallback = root.dataset.fallback || '/';
    var lpSlug = root.dataset.lp || '';
    var passUtm = true; // utm_* e fbclid da URL são sempre repassados ao checkout (setting removida da section)
    var cta = root.querySelector('[data-pkx-cta]');
    var next = root.querySelector('[data-pkx-next]');
    var back = root.querySelector('[data-pkx-back]');
    var steps = root.querySelector('[data-pkx-steps]');
    var sticky = root.querySelector('[data-pkx-sticky]');
    var stickyBtn = root.querySelector('[data-pkx-sticky-btn]');
    var buyBlock = root.querySelector('[data-pkx-buy]');
    var stepNow = 1;

    function kit() { return root.querySelector('input[name="kit"]:checked'); }
    function sabor() { return root.querySelector('input[name="sabor"]:checked'); }
    function codes(k) { try { return JSON.parse(k.dataset.codes || '{}'); } catch (e) { return {}; } }

    function track(ev) {
      try {
        var k = kit(), s = sabor();
        DL.push({ event: ev, pk_lp: lpSlug, pk_kit: k && k.value, pk_flavor: s && s.value, pk_price: k ? +k.dataset.qty * +k.dataset.unit : null });
      } catch (e) {}
    }

    function link(k, s) {
      var map = codes(k), code = map[s.value];
      var u = code ? yampiBase + code : fallback;
      try {
        var x = new URL(u, location.origin);
        if (passUtm) {
          var p = new URLSearchParams(location.search);
          p.forEach(function (v, key) { if (!x.searchParams.has(key)) x.searchParams.set(key, v); });
        }
        if (lpSlug) {
          if (!x.searchParams.has('metadata[lp]')) x.searchParams.set('metadata[lp]', lpSlug);
          /* identifica a LP mesmo quando o anúncio não traz utm_content */
          if (!x.searchParams.has('utm_content')) x.searchParams.set('utm_content', lpSlug);
        }
        u = x.toString();
      } catch (e) {}
      return u;
    }

    function update() {
      var k = kit(); if (!k) return;
      var qty = +k.dataset.qty, unit = +k.dataset.unit, one = qty === 1;
      /* sabores só para kits (ex.: Misto) somem no kit de 1 */
      root.querySelectorAll('input[name="sabor"][data-multi-only]').forEach(function (i) {
        var lab = i.closest('label');
        lab.hidden = one; i.disabled = one;
        if (one && i.checked) {
          var first = root.querySelector('input[name="sabor"]:not([data-multi-only])');
          if (first) first.checked = true;
        }
      });
      var flavors = root.querySelector('[data-pkx-flavors]');
      if (flavors) flavors.classList.toggle('is-one', one);
      var s = sabor();
      var total = qty * unit, from = qty * base;
      root.querySelectorAll('[data-pkx-total]').forEach(function (e) { e.textContent = fmt(total); });
      root.querySelectorAll('[data-pkx-from]').forEach(function (e) { e.textContent = fmt(from); e.hidden = (from <= total); });
      root.querySelectorAll('[data-pkx-unit]').forEach(function (e) { e.textContent = fmt(unit); });
      root.querySelectorAll('[data-pkx-kitname]').forEach(function (e) { e.textContent = k.dataset.name || ''; });
      var off = base ? Math.round((1 - unit / base) * 100) : 0;
      root.querySelectorAll('[data-pkx-off]').forEach(function (e) { e.textContent = off + '% off'; e.hidden = off <= 0; });
      var unlock = root.querySelector('[data-pkx-unlock]');
      if (unlock) {
        var maxMin = 1;
        root.querySelectorAll('.prize').forEach(function (p) { maxMin = Math.max(maxMin, +p.dataset.min || 1); });
        unlock.style.setProperty('--fill', Math.min(100, Math.round(qty / maxMin * 100)) + '%');
      }
      root.querySelectorAll('.prize').forEach(function (p) {
        var locked = qty < +p.dataset.min;
        p.classList.toggle('is-locked', locked);
        var label = p.querySelector('p');
        if (label) p.setAttribute('aria-label', label.textContent + (locked ? ': liberado no kit de ' + p.dataset.min + '+' : ': incluído'));
      });
      /* Pix, parcelas e preço por porção */
      var pixPct = +root.dataset.pixPct || 0, inst = +root.dataset.installments || 0;
      root.querySelectorAll('[data-pkx-pay]').forEach(function (e) {
        var parts = [];
        if (pixPct > 0) parts.push('<b>' + fmt(total * (1 - pixPct / 100)) + ' no Pix</b> (' + pixPct + '% off)');
        if (inst > 1) parts.push('ou ' + inst + 'x de ' + fmt2(total / inst) + ' ' + 'sem juros');
        e.innerHTML = parts.join(' · '); e.hidden = parts.length === 0;
      });
      var gift = +k.dataset.gift || 0, giftLabel = root.dataset.giftLabel || '+ R$ {valor} em brindes!';
      root.querySelectorAll('[data-pkx-gift]').forEach(function (e) {
        if (gift > 0) { e.textContent = giftLabel.replace('{valor}', Math.round(gift).toLocaleString('pt-BR')); e.hidden = false; } else { e.hidden = true; }
      });
      if (cta && s) cta.href = link(k, s);
      syncSticky();
    }

    function syncSticky() {
      if (!stickyBtn) return;
      var k = kit();
      root.querySelectorAll('[data-pkx-sticky-total]').forEach(function (e) { if (k) e.textContent = fmt(+k.dataset.qty * +k.dataset.unit); });
      root.querySelectorAll('[data-pkx-sticky-kit]').forEach(function (e) { if (k) e.textContent = k.dataset.name || ''; });
      if (stepNow === 1 || !cta) { stickyBtn.textContent = stickyBtn.dataset.labelStep1 || 'Escolher sabor'; stickyBtn.setAttribute('href', '#' + (buyBlock ? buyBlock.id : '')); }
      else { stickyBtn.textContent = stickyBtn.dataset.labelStep2 || 'Ir para o checkout'; stickyBtn.setAttribute('href', cta.href); }
    }

    function showStep(n, fromPop) {
      if (!steps) return;
      stepNow = n;
      steps.querySelectorAll('.stp__pane').forEach(function (p) { p.hidden = +p.dataset.pane !== n; });
      steps.querySelectorAll('.stp li').forEach(function (li) { var k = +li.dataset.s; li.classList.toggle('is-on', k === n); li.classList.toggle('is-done', k < n); });
      update();
      var top = steps.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      var pane = steps.querySelector('.stp__pane[data-pane="' + n + '"]');
      try { pane.focus({ preventScroll: true }); } catch (e) {}
      if (n === 2) { track('pk_view_flavors'); if (!fromPop) { try { history.pushState({ pkx: root.id }, ''); } catch (e) {} } }
    }

    root.querySelectorAll('input[name="kit"]').forEach(function (i) { i.addEventListener('change', function () { update(); track('pk_select_offer'); }); });
    root.querySelectorAll('input[name="sabor"]').forEach(function (i) { i.addEventListener('change', function () { update(); track('pk_select_flavor'); }); });
    if (cta) cta.addEventListener('click', function () { track('pk_checkout'); pixel('InitiateCheckout'); });
    function pixel(ev) {
      try {
        var k = kit(), value = k ? +k.dataset.qty * +k.dataset.unit : 0;
        var data = { value: value, currency: 'BRL', content_name: lpSlug || document.title, content_type: 'product' };
        if (window.fbq) fbq('track', ev, data);
        if (window.ttq && ttq.track) ttq.track(ev === 'ViewContent' ? 'ViewContent' : (ev === 'AddToCart' ? 'AddToCart' : 'InitiateCheckout'), { value: value, currency: 'BRL' });
      } catch (e) {}
    }
    if (next) next.addEventListener('click', function () { showStep(2); pixel('AddToCart'); });
    setTimeout(function () { pixel('ViewContent'); }, 1500);
    if (back) back.addEventListener('click', function () {
      try { if (history.state && history.state.pkx === root.id) { history.back(); return; } } catch (e) {}
      showStep(1, true);
    });
    window.addEventListener('popstate', function () { if (stepNow === 2) showStep(1, true); });
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
      if (stepNow === 1 && steps) { e.preventDefault(); showStep(2); }
      else if (stickyBtn.getAttribute('href').charAt(0) === '#') { e.preventDefault(); }
    });
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle('show', !e[0].isIntersecting); }, { threshold: 0 }).observe(buyBlock);
    }

    /* Modal "Ingredientes": conteúdo vem dos data-* de cada sabor */
    var mdl = root.querySelector('[data-pkx-mdl]'), lastFocus = null;
    function openMdl(btn) {
      if (!mdl) return;
      var lab = btn.closest('label'), inp = lab && lab.querySelector('input');
      if (!inp) return;
      mdl.querySelector('[data-pkx-mdl-t]').textContent = (root.dataset.ingTitle || 'Ingredientes') + ' · ' + (inp.dataset.name || '');
      var b = mdl.querySelector('[data-pkx-mdl-b]'); b.textContent = '';
      [inp.dataset.ing, root.dataset.ingBase].filter(Boolean).forEach(function (t) { var p = document.createElement('p'); p.textContent = t; b.appendChild(p); });
      lastFocus = btn; mdl.hidden = false; document.documentElement.style.overflow = 'hidden';
      var ok = mdl.querySelector('.mdl__ok'); if (ok) ok.focus();
    }
    function closeMdl() { if (!mdl || mdl.hidden) return; mdl.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {} }
    root.querySelectorAll('.flv__ing').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openMdl(b); }); });
    if (mdl) {
      mdl.querySelectorAll('.mdl__x,.mdl__ok').forEach(function (b) { b.addEventListener('click', closeMdl); });
      mdl.addEventListener('click', function (e) { if (e.target === mdl) closeMdl(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMdl();
        if (e.key === 'Tab' && !mdl.hidden) {
          var f = mdl.querySelectorAll('button'), a = f[0], z = f[f.length - 1];
          if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
          else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
        }
      });
    }

    /* Galeria */
    var main = root.querySelector('[data-pkx-main] img');
    root.querySelectorAll('.gallery__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.querySelector('img').alt;
        root.querySelectorAll('.gallery__thumbs button').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    update();
  }

  /* ========== Carrossel (recomendações) ========== */
  function initCar(c) {
    var track = c.querySelector('.car__track'), prev = c.querySelector('[data-dir="-1"]'), next = c.querySelector('[data-dir="1"]');
    if (!track || !prev || !next) return;
    function step() { var li = track.querySelector('.person'); return li ? li.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 300; }
    function sync() { prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
  }

  /* ========== Avaliações: ver mais ========== */
  function initReviews(sec) {
    var btn = sec.querySelector('[data-pkx-more]'); if (!btn) return;
    btn.addEventListener('click', function () {
      var open = sec.classList.toggle('is-open');
      btn.textContent = open ? (btn.dataset.less || 'Ver menos') : (btn.dataset.more || 'Ver mais depoimentos');
    });
  }

  /* ========== Vídeos de prova social: toca mudo ao entrar na tela ========== */
  function initVideos(sec) {
    var vids = sec.querySelectorAll('video'); if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.playsInline = true;
      v.addEventListener('click', function () { if (v.muted) { v.muted = false; v.controls = true; } });
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting && en.intersectionRatio > 0.6) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: [0, 0.6, 1] });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pkx-videos]').forEach(initVideos);
    (scope || document).querySelectorAll('[data-pkx-oferta]').forEach(initOferta);
    (scope || document).querySelectorAll('[data-pkx-car]').forEach(initCar);
    (scope || document).querySelectorAll('[data-pkx-reviews]').forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  /* editor de tema: reinicializa a section recarregada */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
